import type { LandingCompareContent, LandingConfiguratorContent } from "../types";

// Register: this file settles the pronoun the rest of the German set follows.
// "DEIN ANTEIL" in landing-why.ts already committed to the informal "du", which
// is the convention in German prop-trading and retail-broker copy, and mixing it
// with "Sie" mid-page reads as two writers. Recorded in the Phase 13 package so
// the client can overrule it once rather than per string.
export const landingCompare: LandingCompareContent = {
  title: { lead: "Ein anderes Modell,", highlight: "mit Absicht", tail: "." },
  sub: "Ein direkter Vergleich mit dem konventionellen Prop-Firm-Modell bei Drawdown, Splits, Auszahlungen, Regelklarheit und Skalierung.",
  headers: {
    otherFirms: "ANDERE FIRMEN",
    otherFirmsSub: "Der alte Weg",
    // PROPER NOUN — the brand. Identical in every locale.
    ours: "FLEX FUND",
    oursSub: "So sollte es sein",
  },
  // [de-review] Every row on this table makes a comparative claim about how
  // competitors operate and what Flex Fund guarantees instead. This is the
  // single most commercially exposed block on the site.
  rows: {
    drawdownRules: {
      topic: "Drawdown-Regeln",
      legacy: "Versteckte Trailing-Drawdowns schließen dein Konto an einem Gewinntag.",
      ours: "Statischer Drawdown auf das Startkapital. Keine Überraschungen.",
    },
    profitSplits: {
      topic: "Profit-Splits",
      legacy: "Versprochene Splits sinken nach der ersten Auszahlung.",
      ours: "80 % ab Tag eins. Bis zu 90 % mit dem optionalen Add-on.",
    },
    payoutSpeed: {
      topic: "Auszahlungsgeschwindigkeit",
      // German typographic quotation marks, so no escaping is needed here.
      legacy: "Vage „Wir melden uns“-Zeitangaben.",
      ours: "Feste Auszahlungsfenster. Bearbeitung in 48–72 Geschäftsstunden.",
    },
    ruleClarity: {
      topic: "Regelklarheit",
      legacy: "Weiche Regeln, erfunden nach einem Verstoß. Überraschende News-Verbote und verschobene Ziele.",
      ours: "Ein Regelwerk. Vorab dokumentiert. Konsequent angewendet.",
    },
    accountScaling: {
      topic: "Konto-Skalierung",
      // German writes large amounts with a dot as the thousands separator and
      // the currency symbol after the figure.
      legacy: "Gedeckelt bei 200.000 $ mit willkürlichen Meilensteinen.",
      ours: "Skalierung bis 1 Mio. $ mit dokumentierten Wachstumsstufen.",
    },
  },
};

export const landingConfigurator: LandingConfiguratorContent = {
  title: { lead: "Konfiguriere deine ", highlight: "Evaluation." },
  sub: "Modell wählen, Größe wählen und die exakten Bedingungen sehen, die du tradest.",
  // "2-Phasen" matches the hero ticket's wording; "1-Phase" is the singular so
  // the control does not read as a grammatical error.
  models: { twoStep: "2-Phasen", oneStep: "1-Phase" },
  accountSize: "KONTOGRÖSSE",
  dailyDrawdown: "TÄGLICHER DRAWDOWN",
  maxDrawdown: "MAX. DRAWDOWN",
  ticketLabel: "TICKET",
  youPay: "DU ZAHLST",
};
